import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 
import { useQuery, useQueryClient } from '@tanstack/react-query';
import API_URL from './api/config';

function SignupTribe() {
    const navigate = useNavigate();
   
    const { data: tribeImages = [], isLoading, isError } = useQuery({
        queryKey: ['tribeImages'],
        queryFn: () =>
          axios.get(`${API_URL}/reg-signup-tribe-images-api`).then((res) => {
            if (res.data.Status === "Success") {
              return res.data.images;
            } else {
              throw new Error(res.data.Message || "Failed to fetch tribe images");
            }
          }),
        staleTime: 0,
        cacheTime: Infinity,
      });


    
      const {
        data: tribeCaptions = [],
        isLoading: captionLoading,
        isError: captionError,
      } = useQuery({
        queryKey: ['tribeCaptions'],
        queryFn: () =>
          axios.get(`${API_URL}/reg-signup-tribe-caption-api`).then((res) => {
            if (res.data.Status === "Success") return res.data.captions;
            else throw new Error("Caption fetch failed");
          }),
        staleTime: 0,
        cacheTime: Infinity,
      });
    
      const [selectedTribe, setSelectedTribe] = useState("");
      const { data: tribes = [], isLoading: tribeLoading } = useQuery({
        queryKey: ['tribes'],
        queryFn: () =>
            axios.get(`${API_URL}/reg-signup-tribes-api`, { withCredentials: true }).then(res => {
                if (res.data.Status === "Success") return res.data.tribes;
                throw new Error("No tribes found");
            }),
    });

    const [selectText, setSelectText] = useState("");
    useEffect(() => {
        const fetchUserInfo = async () => {
            try {
                const res = await axios.get(`${API_URL}/reg-signup-tribe-select-text-api`, { withCredentials: true });
                if (res.data.Status === "Success") {
                    setSelectText(res.data.selectText);
                }
            } catch (error) {
                console.error("Error fetching tribe select label:", error);
            }
        };
    
        fetchUserInfo();
    }, []);



    const handleTribeSubmit = async () => {
        if (!selectedTribe) {
            toast.error("Please select a tribe first.");
            return;
        }
    
        try {
            const res = await axios.post(`${API_URL}/reg-signup-tribe-update-api`, 
                { tribe_id: selectedTribe },
                { withCredentials: true }
            );
    
            if (res.data.Status === "Success") {
                navigate(res.data.redirect);
            } else {
                toast.error("Failed to update tribe.");
            }
        } catch (error) {
            console.error("Tribe update failed:", error);
            toast.error("Something went wrong.");
        }
    };


    return (
      
        <div
  className="min-vh-100 h-100 d-grid align-items-start"
  style={{
    backgroundImage: isLoading
      ? 'none'
      : tribeImages.length > 0
      ? `linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url(${API_URL}/images/${tribeImages[0].image_name})`
      : 'none',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  }}
    >



  <div className="row align-items-center g-3 container m-auto">
    
    <div className="col-12 col-md-6 text-white">
      <p className="display-5">
        {captionLoading ? 'Loading caption...' : (
          tribeCaptions.map((caption, index) => (
            <span key={index}>{caption.caption}</span>
          ))
        )}
      </p>
    </div>

    <div className="col-12 col-md-5 col-xl-4 mx-auto">
      <div className="card bg-secondary text-white">
        <div className="card-body">
          <p className="h4 text-center">{selectText}</p>
         
            <div className="row g-3 align-items-end">
              <div className="col-12">
              <ToastContainer />

                <select
                  className="form-select"
                  value={selectedTribe}
                  onChange={(e) => setSelectedTribe(e.target.value)}
                >
                  <option value="">Select Tribe</option>
                  {tribeLoading ? (
                    <option disabled>Loading tribes...</option>
                  ) : (
                    tribes.map((tribe) => (
                      <option key={tribe.id} value={tribe.id}>
                        {tribe.tribe_name}
                      </option>
                    ))
                  )}
                </select>
              </div>

              <div className="col-12 mb-3">
                <div className="d-flex justify-content-between">
                  <div className="col-md-4"></div>
                  <button
                    onClick={handleTribeSubmit} className="btn btn-primary" type="submit"
                  >
                    Continue
                  </button>
                </div>
              </div>
            </div>
          
        </div>
      </div>
    </div>
  </div>
</div>



    );
}

export default SignupTribe;
